import React from "react"
import NavBar from "../components/NavBar"
import Home from "../components/Home"
import ImpactSection from "../components/ImpactSection"
import BlogSection from "../components/BlogSection"
import KnowUsSection from "../components/KnowUsSection"
import Footer from "../components/Footer"
import SEO from "../components/Seo"

export default function HomeScreen() {
  return (
    <div>
      <SEO
        title="Home Page"
        description="Welcome to InfraDigital Foundation main web page. Explore our main goal, core values, and progress through this site."
      />
      <NavBar color="blue" />
      <Home />
      <ImpactSection />
      <BlogSection />
      <KnowUsSection />
      <Footer />
    </div>
  )
}
